function findPLUByCode(code, productCode) {
    let foundItem = productCode.find(item => item.code === code);
    return foundItem ? foundItem.plu : null;
 
}
function processElements(productCode) {
    $('.product').each(function() {
        var code = $(this).find('.p-code span[data-micro="sku"]').text().trim()
        let plu = findPLUByCode(code, productCode);
        if (plu) {
                if(!$(this).find('.supplierProductBox').length){
                    $(this).find('.prices').append('<div class="supplierProductBox">U dodavatele '+plu+' ks</div>')
                
            }
        }
        
    });    
}
let storedData = sessionStorage.getItem("pluData");
if (storedData) {
    let pluData = JSON.parse(storedData);
    $(document).ready(function(){
        processElements(pluData);
    });
        
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        processElements(pluData);
    });
    document.addEventListener('ShoptetPageSortingChanged', function() {
        processElements(pluData);
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        processElements(pluData);
    });
} else {
    $.getJSON("/user/documents/plu.json?v"+new Date().getMinutes(), function(data) {
        sessionStorage.setItem("pluData", JSON.stringify(data));
        $(document).ready(function(){
            processElements(data);
        });
            
        document.addEventListener('ShoptetDOMPageContentLoaded', function() {
            processElements(data);
        });
        document.addEventListener('ShoptetPageSortingChanged', function() {
            processElements(data);
        });
        document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
            processElements(data);
        });
    });
}


